import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "preview-footer" }
const _hoisted_2 = { class: "preview-footer__contents" }
const _hoisted_3 = { class: "preview-footer__row" }
const _hoisted_4 = {
  key: 1,
  class: "preview-footer__button-wrapper",
  id: "exportButton"
}
const _hoisted_5 = {
  key: 2,
  class: "preview-footer__social-info"
}
const _hoisted_6 = { class: "preview-footer__duration-message" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Recommended social media durations", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "TikTok:"),
    /*#__PURE__*/_createTextVNode(" 3 sec - 10 min")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Instagram Reels:"),
    /*#__PURE__*/_createTextVNode(" 15 - 60 sec")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Instagram Video Post:"),
    /*#__PURE__*/_createTextVNode(" 3 - 10 min")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "Spotify Canvas:"),
    /*#__PURE__*/_createTextVNode(" 3 - 8 sec")
  ])
], -1)

import AudioControls from '@/components/preview/AudioControls.vue'
import OrientationSwitcher from '@/components/preview/OrientationSwitcher.vue'
import BigButton from '@/components/common/BigButton.vue'
import AudioPlayer from '@/components/preview/AudioPlayer.vue'
import { Orientation } from '@/types'
import { computed, ref } from 'vue'
import { useApplicationStore } from '@/store/application-store'
import { useProjectStore } from '@/store/project-store'
import GtmHelper from '@/analytics/gtm-helper'
import useAudioEngine from '@/composables/UseAudioEngine'
import AudioTrimmer from '@/components/preview/AudioTrimmer.vue'
import Tooltip from '@/components/onboarding/Tooltip.vue'
import InformationIcon from '@/assets/InformationIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewFooter',
  props: {
    showControls: { type: Boolean },
    isAudioLoading: { type: Boolean },
    trackName: null,
    orientation: null
  },
  emits: ["orientationSelected", "fileSelected", "openVideoExport", "toggleWaveform"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'orientationSelected', orientation: Orientation): void
  (event: 'fileSelected', file: File): void
  (event: 'openVideoExport'): void
  (event: 'toggleWaveform'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  showControls: boolean
  isAudioLoading: boolean
  trackName: string
  orientation: Orientation
};

const showWaveform = ref(false)
const toggleHovered = ref(false)



const gtmHelper = GtmHelper.getInstance()
const projectStore = useProjectStore()
const applicationStore = useApplicationStore()

const { audioCurrentTimeSeconds, audioDurationSeconds, audioBufferWaveformData } = useAudioEngine()



const resetTrimFlag = ref(false)

const buttonText = computed(() => `Export ${props.orientation}`)

const onExportVideo = () => {
  applicationStore.deselectAllEntities()
  emits('openVideoExport')

  gtmHelper.triggerExportGtmEvents(projectStore, audioDurationSeconds.value)
}

const onOrientationSelected = (orientation: Orientation) => {
  emits('orientationSelected', orientation)
}

const onFileSelected = (file: File) => {
  emits('fileSelected', file)
}

const onToggleWaveform = () => {
  showWaveform.value = !showWaveform.value
  emits('toggleWaveform')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "preview-footer__fade-transition" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(audioDurationSeconds))
            ? _withDirectives((_openBlock(), _createBlock(AudioPlayer, {
                key: 0,
                "total-time": _unref(audioDurationSeconds),
                "current-time": _unref(audioCurrentTimeSeconds)
              }, null, 8, ["total-time", "current-time"])), [
                [_vShow, __props.showControls && !showWaveform.value]
              ])
            : _createCommentVNode("", true),
          (_unref(audioBufferWaveformData))
            ? _withDirectives((_openBlock(), _createBlock(AudioTrimmer, {
                key: 1,
                "current-time": _unref(audioCurrentTimeSeconds),
                "total-time": _unref(audioDurationSeconds),
                "audio-buffer-waveform-data": _unref(audioBufferWaveformData),
                "reset-trim-flag": resetTrimFlag.value
              }, null, 8, ["current-time", "total-time", "audio-buffer-waveform-data", "reset-trim-flag"])), [
                [_vShow, showWaveform.value]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(AudioControls, {
              "is-audio-loading": __props.isAudioLoading,
              "track-name": __props.trackName,
              "show-waveform": showWaveform.value,
              onFileSelected: onFileSelected,
              onToggleWaveform: _cache[0] || (_cache[0] = ($event: any) => (onToggleWaveform())),
              onResetTrim: _cache[1] || (_cache[1] = ($event: any) => (resetTrimFlag.value = !resetTrimFlag.value))
            }, null, 8, ["is-audio-loading", "track-name", "show-waveform"]),
            (!showWaveform.value)
              ? (_openBlock(), _createBlock(OrientationSwitcher, {
                  key: 0,
                  orientation: __props.orientation,
                  onOrientationSelected: onOrientationSelected
                }, null, 8, ["orientation"]))
              : _createCommentVNode("", true),
            (!showWaveform.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(BigButton, {
                    text: _unref(buttonText),
                    "is-disabled": false,
                    "is-loading": false,
                    type: "secondary",
                    onClick: onExportVideo
                  }, null, 8, ["text"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(InformationIcon), {
                      id: "infoIconId",
                      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (toggleHovered.value = true)),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (toggleHovered.value = false))
                    }),
                    _hoisted_7
                  ]),
                  _createVNode(BigButton, {
                    text: "Save",
                    type: "secondary",
                    "is-disabled": false,
                    "is-loading": false,
                    onClick: onToggleWaveform
                  })
                ])),
            _createVNode(Tooltip, {
              class: _normalizeClass(['duration-tooltip', { 'duration-tooltip--hovered' : toggleHovered.value }]),
              "reference-element-id": "infoIconId",
              placement: "top",
              "is-active": toggleHovered.value
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["class", "is-active"])
          ], 512), [
            [_vShow, __props.showControls]
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})